import { PtacTerminalType } from '@alpinehomeair/common';

export type TerminalUnitId = PtacTerminalType;

export type TerminalUnitOption = {
  id: TerminalUnitId;
  label: string;
  shortLabel: string;
};

export const TERMINAL_UNIT_OPTIONS: readonly TerminalUnitOption[] = [
  { id: 'ptac', label: 'Air Conditioner (PTAC)', shortLabel: 'PTAC' },
  { id: 'pthp', label: 'Heat Pump (PTHP)', shortLabel: 'PTHP' }
];
